import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import {
  insertCustomComponents,
} from './common';
import Utils from '../../utils';
import { Context } from '../context';
import CiblerAPI from '../ciblerApi';

export default class Button extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      open: false,
    };

    const emplacement = Utils.getCampaignData(props.emplacement, '');

    const bellSize = Utils.getCampaignData(props.bellSize, 100);

    this.notifStyle = {
      transition: 'height 500ms ,width 500ms, bottom 500ms, left 500ms, top 500ms, right 500ms',
      left: emplacement.includes('right') ? 'initial' : `calc(${Utils.getCampaignData(props.left)} - ${bellSize / 2}px)`,
      bottom: emplacement.includes('top') ? 'initial' : `calc(${Utils.getCampaignData(props.bottom)} - ${bellSize / 2}px)`,
      right: emplacement.includes('right') ? `calc(${Utils.getCampaignData(props.right)} - ${bellSize / 2}px)` : 'initial',
      top: emplacement.includes('top') ? `calc(${Utils.getCampaignData(props.top)} - ${bellSize / 2}px)` : 'initial',
      height: `${bellSize}px`,
      width: `${bellSize}px`,
      position: 'fixed',
      background: `url('${Context.clientUrl}static/${Context.customerId}/${Context.device}/bell.png') center / contain no-repeat`,
      border: 'none',
    };

    this.closeStyle = {
      transition: 'opacity 500ms, width 0s linear 500ms, height 0s linear 500ms',
      opacity: 0,
      overflow: 'hidden',
      width: 0,
      height: 0,
    };
    this.unbound = false;
  }

  componentDidUpdate() {
    insertCustomComponents(this.props);
    const body = document.getElementById(`WioGameBG_${this.props.campaignId}`);
    const acceptButton = body.querySelector('#wioBlockAccept');
    if (acceptButton) {
      acceptButton.onclick = this.handleAccept;
    }
    const discover = body.querySelector('#wioBlockDiscover');
    if (discover) {
      discover.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        CiblerAPI.discoverGift(Context[this.props.campaignId], this.completeGift(this.props.content?.value));
        return false;
      };
    }
  }

  getStyle = () => {
    let style = { transition: 'opacity 500ms', opacity: 1,
      backgroundSize: 'contain', position: 'absolute',
      right: 0, top: '50px', zIndex: 1,
    };

    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Context.device === 'desktop') style.minWidth = '300px';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    if (!this.state.open) {
      style = {
        ...style,
        ...this.closeStyle,
      };
    }

    return style;
  };

  toggleCloseClick = () => {
    if (this.props.openingTrigger === 'over' && Utils.getDevice() !== 'desktop') return;

    this.setState(prevState => ({ open: !prevState.open }));
  }

  toggleCloseOver = (input) => {
    if (this.props.openingTrigger !== 'over') return;
    this.setState({ open: input });
  }

  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';

    return (
      <div style={{ position: 'relative' }}
           onMouseLeave={() => this.toggleCloseOver(false)}
      >
        <div
          id="wioButton"
          style={{cursor: 'pointer'}}
          dangerouslySetInnerHTML={{ __html: this.props.buttonContent.value}}
          onClick={this.toggleCloseClick}
          onMouseEnter={() => this.toggleCloseOver(true)}
        />
        <div
          id="wio_notif"
          style={this.getStyle()}
        >
          <div
            id="wioContent"
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
          <a
            href={`mailto:${Context.helpUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'none',
              position: 'absolute',
              bottom: '2%',
              right: '2%',
            }}
          >
            Besoin d'aide ?
          </a>
          <button
            id="wioBlockExit"
            style={this.getExitStyle()}
            onClick={() => this.setState({ open: false })}
          >
            X
          </button>
        </div>
      </div>
    );
  }
}
